import React from 'react';
import { readinessTone } from 'modules/FreeSupplier/app/state/gaps';

// Mini progress bar + percentage pill, visual language and color thresholds
// borrowed from Suppliers/components/SupplierDataScore.jsx (≥80 green,
// ≥50 amber, else red).
export default function ReadinessScore({ score, label = 'Portal readiness' }) {
  const tone = readinessTone(score);
  return (
    <div className="flex items-center gap-2.5">
      <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 whitespace-nowrap">
        {label}
      </span>
      <div className="w-24 h-1.5 rounded-full bg-slate-100 overflow-hidden">
        <div
          className={`h-full rounded-full transition-all ${tone.bar}`}
          style={{ width: `${score}%` }}
        />
      </div>
      <span className={`text-[11px] font-bold rounded-full px-2 py-0.5 ${tone.text} ${tone.bg}`}>
        {score}%
      </span>
    </div>
  );
}
